'use strict';

function CheckoutController(Contributions, _, gettextCatalog, $scope) {
  /**
   * Lifecycle hook used for initialization work
   */
  this.$onInit = () => {
    this.contribution = new Contributions();
    this.consents = {};
    this.payerInfoIncomplete = false;
    this.phoneType = 'mobile';
    this.phoneTypes = [
      {
        name: gettextCatalog.getString('Mobile'),
        value: 'mobile',
      },
      {
        name: gettextCatalog.getString('Home'),
        value: 'home',
      },
      {
        name: gettextCatalog.getString('Work'),
        value: 'work',
      },
    ];

    this.hasFixedValues = !!(
      this.data.campaign.smallDonation ||
      this.data.campaign.mediumDonation ||
      this.data.campaign.largeDonation
    );
    this.showButtons = this.hasFixedValues;
  };

  /**
   * Calculate contribution amount with Gift Aid added
   */
  this.claimGiftAid = () =>
    _.sum([this.contribution.amount, (25 / 100) * this.contribution.amount]);

  this.setAmount = (amount) => {
    this.contribution.amount = amount;
  };

  /**
   * Get an anchor tag that links to the consent
   */
  this.getConsentTypeLink = (consentType) =>
    `<a href='${consentType.link}' target='_blank' rel='noopener noreferrer'>${consentType.label}</a>`;

  /**
   * Get an anchor tag that links to the organization's privacy policy
   */
  this.getPrivacyPolicyLink = () =>
    `<a href='${
      this.data.organization.privacyPolicy
    }' target='_blank' rel='noopener noreferrer'>${gettextCatalog.getString(
      'privacy policy'
    )}</a>`;

  /**
   * createPaymentData
   *
   * A unique function to every view that uses Stripe. Each may have different parameters
   * that need to be passed into payments
   **/
  this.createPaymentData = () => {
    let payment = _.extend(this.contribution, {
      paymentType: this.paymentType,
      contributionId: this.data.campaign.id,
      currency: this.data.account.currency.toUpperCase(),
      giftAid: this.contribution.giftAid || !!this.contribution.cpr || false,
      churchName: this.data.organization.name,
      organizationId: this.data.organization.id,
    });

    let phoneElem = angular.element('#hp-inputPhoneNumber');
    let phone = phoneElem.intlTelInput('isValidNumber')
      ? phoneElem.intlTelInput('getNumber')
      : null;
    this.contribution.phone = this.phoneType === 'mobile' ? phone : null;
    this.contribution.homePhone = this.phoneType === 'home' ? phone : null;
    this.contribution.workPhone = this.phoneType === 'work' ? phone : null;
    // this.consents =
    // {
    //  '69a07471-13b8-4165-bdcd-8534a28489fc', false,
    //  '45de90e1-453a-49c6-bcbd-ddc0cfabb6a6', true
    // }
    payment.consentTypes =
      this.consents &&
      Object.entries(this.consents)
        .filter(([key, value]) => value) // eslint-disable-line no-unused-vars
        .map(([key]) => key);

    payment = _(payment).omit(_.isNull).value();

    if (this.payerInfo) {
      payment = _.extend(payment, this.payerInfo);
    }

    return payment;
  };

  this.paymentInfoFinished = (finished, paymentType) => {
    this.paymentType = paymentType;
    this.paymentInfoValid = finished;
    $scope.$apply();
  };

  this.updatePayerInfo = (payerInfo) => {
    this.payerInfo = payerInfo;

    // A flag for submit button to only enable when payerInfo is entered
    this.payerInfoIncomplete =
      !payerInfo.payerFirstName ||
      !payerInfo.payerLastName ||
      !payerInfo.payerEmail;
  };

  this.paymentStatus = (success, error) => {
    if (success) {
      this.busy = false;
      this.fulfilled = true;
    } else {
      this.busy = false;
      this.error = error;
    }
    $scope.$apply();
  };

  this.contribute = () => {
    this.busy = true;
    let payment = this.createPaymentData();

    // Submit payment to /payments api
    payment.$save(
      {
        organizationId: this.data.organization.id,
      },
      (response) => {
        // Updating paymentIntents will trigger a listener in stripe-payment repo and submit the payment
        this.paymentIntentSecret = response.paymentIntent.secret;
        this.paymentIntentId = response.paymentIntent.id;
      },
      (err) => {
        this.busy = false;
        this.error = err;
        throw new Error(err && err.data && err.data.message);
      }
    );
  };
}

angular
  .module('cdPay.components.projectCheckout', [])

  .component('cdProjectCheckout', {
    templateUrl: 'components/project-checkout/project-checkout.html',
    controller: CheckoutController,
    bindings: {
      data: '<cdData',
    },
  });
